<div class="logs-modal">
  <h4>{{ 'CONFIGURATION.LOGS.TITLE' | translate }}</h4>
  <div *ngIf="isLoading" class="loader-overlay">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <div *ngIf="!isLoading" class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button
            [value]="element.id"
            [checked]="selectedAction?.id === element.id"
            (change)="selectAction(element)">
          </mat-radio-button>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of ['userName', 'actionType', 'actionTimeUTC']" matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef>{{ getColumnHeaderName(column) }}</th>
        <td mat-cell *matCellDef="let element" [ngSwitch]="column">
          <ng-template [ngSwitchCase]="'actionTimeUTC'">
            {{ element.actionTimeUTC | utcToLocal: this.dateFormat }}
          </ng-template>
          <ng-template ngSwitchDefault>
            {{ element[column] }}
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row
          *matRowDef="let element; columns: columnsToDisplay"
          class="selectable-row"
          [class.selected-row]="selectedAction?.id === element.id"
          (click)="selectAction(element)">
      </tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[100, 200, 500]"
                 [pageIndex]="this.pageIndex"
                 [pageSize]="this.pageSize"
                 [length]="this.totalItems"
                 (page)="this.handlePageEvent($event)"
                 showFirstLastButtons
                 *ngIf="!isLoading">
  </mat-paginator>

  <div class="buttons">
    <button mat-button
            color="primary"
            [disabled]="!selectedAction"
            (click)="showDiff()">
      {{ 'CONFIGURATION.LOGS.SHOW_DIFF' | translate }}
    </button>
    <button mat-button
            color="warn"
            [disabled]="!selectedAction || isRollbackInProgress"
            (click)="rollback()">
      {{ 'CONFIGURATION.LOGS.ROLLBACK_TO' | translate }}
    </button>
  </div>
</div>
